import React from 'react';
import { ArrowLeft, ChevronRight, Coins } from 'lucide-react';
interface Province {
  id: string;
  name: string;
  cost: string;
  siteCount: number;
}
interface OvertimeCostProvinceListProps {
  onBack: () => void;
  onProvinceClick?: (provinceId: string) => void;
}
const provinces: Province[] = [{
  id: 'wc',
  name: 'Western Cape',
  cost: 'R320,000',
  siteCount: 5
}, {
  id: 'kzn',
  name: 'KwaZulu-Natal',
  cost: 'R285,000',
  siteCount: 4
}, {
  id: 'gp',
  name: 'Gauteng',
  cost: 'R242,500',
  siteCount: 3
}];
export function OvertimeCostProvinceList({
  onBack,
  onProvinceClick
}: OvertimeCostProvinceListProps) {
  return <div className="flex flex-col space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-300" data-id="element-850">
      {/* Header Section */}
      <div className="flex flex-col space-y-2" data-id="element-851">
        <button onClick={onBack} className="group flex w-fit items-center text-sm font-medium text-[#5a7280] hover:text-[#062133] transition-colors min-h-[44px] px-2 -ml-2 rounded-lg hover:bg-[#062133]/5" aria-label="Back to dashboard" data-id="element-852">
          <ArrowLeft className="mr-1 h-4 w-4 transition-transform group-hover:-translate-x-1" data-id="element-853" />
          Back to Dashboard
        </button>

        <div className="flex items-center justify-between" data-id="element-854">
          <div data-id="element-855">
            <h2 className="text-2xl font-bold text-[#062133]" data-id="element-856">
              Projected Overtime Cost (R847,500)
            </h2>
            <p className="text-[#5a7280]" data-id="element-857">Breakdown by province</p>
          </div>
        </div>
      </div>

      {/* Province List Card */}
      <div className="overflow-hidden rounded-xl border border-[#e5e5e5] bg-white shadow-sm" data-id="element-858">
        <div className="divide-y divide-[#e5e5e5]" data-id="element-859">
          {provinces.map(province => <button key={province.id} onClick={() => onProvinceClick?.(province.id)} className="group flex w-full items-center justify-between p-5 text-left transition-all hover:bg-[#fafaf9] focus:outline-none focus:bg-[#fafaf9] min-h-[72px]" data-id="element-860">
              <div className="flex items-center gap-4" data-id="element-861">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-rose-500/10 text-rose-600" data-id="element-862">
                  <Coins className="h-5 w-5" data-id="element-863" />
                </div>
                <div data-id="element-864">
                  <span className="block text-lg font-semibold text-[#062133]" data-id="element-865">
                    {province.name}
                  </span>
                  <div className="flex items-center gap-2 text-sm text-[#5a7280]" data-id="element-866">
                    <span className="font-medium text-rose-600" data-id="element-867">
                      {province.cost}
                    </span>
                    <span data-id="element-868">•</span>
                    <span data-id="element-869">{province.siteCount} sites</span>
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-4" data-id="element-870">
                <ChevronRight className="h-5 w-5 text-[#e5e5e5] transition-colors group-hover:text-[#062133]" data-id="element-871" />
              </div>
            </button>)}
        </div>
      </div>
    </div>;
}